import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const AdminDashboard = lazy(() => import('../pages/admin/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/admin',
    element: <AdminDashboard />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
